import {Form} from '@mintdata-wsp/common/components/form/Form';
import {IFormFieldState} from '@mintdata-wsp/common/components/formField/FormField';
import {Validators} from '@mintdata-wsp/common/components/validators/Validators';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {RegisterRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/RegisterRequest';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';
const md5 = require('md5');

export class SignUpController
{
    public init()
    {
    }

    @action
    public submitForm(form:Form)
    {
        const {signUpPage} = rootState.ui;

        if (signUpPage.isSignUpInProgress || !form.areAllFieldsValid() || form.areSomeFieldIsEmpty())
            return;

        let formData = form.getFormData();

        const fullName:string           = formData.fullname as string;
        const email:string              = formData.email as string;
        const password:string           = formData.password as string;
        const organizationName:string   = formData.organizationName as string;
        const organizationSiteId:string = formData.organizationSiteId as string;

        form.removeServerErrors();
        signUpPage.isSignUpInProgress = true;

        controllers.user.register(new RegisterRequest(
            organizationName,
            organizationSiteId,
            fullName,
            email.replace('@', '_'),
            md5(password),
            email)
        )
        .then(()=>
        {
            controllers.navigation.toAppHome();
        })
        .catch(action((err)=>
        {
            signUpPage.isSignUpInProgress = false;
            if (ApiError.isError(err))
            {
                form.setServerErrors((err as ApiError).message);
            }
        }));
    }

    public validateFullName(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form, errorMessage: 'Please enter your name'},
        [
            Validators.serverError('fullname'),
            Validators.emptyNotDirtyIsValid(),
            Validators.required(),
            Validators.minLength(1),
            Validators.maxLength(255),
        ]);
    }

    public validateEmail(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
        [
            Validators.serverError('email'),
            Validators.emptyNotDirtyIsValid(),
            Validators.email(),
        ]);
    }

    public validatePassword(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
        [
            Validators.serverError('password'),
            Validators.emptyNotDirtyIsValid(),
            Validators.password(),
        ]);
    }
}
